/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workflow_Save_FailedInputs */

const cs_workflow_save_failed = /** @type {(inputs: Workflow_Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workflow se nepodařilo uložit`)
};

const en_workflow_save_failed = /** @type {(inputs: Workflow_Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not save the workflow`)
};

/**
* | output |
* | --- |
* | "Could not save the workflow" |
*
* @param {Workflow_Save_FailedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const workflow_save_failed = /** @type {((inputs?: Workflow_Save_FailedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workflow_Save_FailedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_workflow_save_failed(inputs)
	return cs_workflow_save_failed(inputs)
});